import React from "react";
import { motion } from "framer-motion";
import { FaCrown } from "react-icons/fa";

export default function PageName({ title, subTitle }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="mb-8 bg-white p-6 rounded-2xl border border-slate-200/80 shadow-xs flex flex-col md:flex-row justify-between items-start md:items-center gap-4"
    >
      <div>
        <div className="flex items-center gap-2">
          <span className="p-2 bg-amber-100 text-amber-700 rounded-lg shadow-xs">
            <FaCrown size={14} />
          </span>
          <h2 className="text-2xl font-bold text-slate-900 tracking-tight">{title}</h2>
        </div>
        {subTitle && (
          <p className="mt-1 text-xs text-slate-500 font-medium pl-9">{subTitle}</p>
        )}
      </div>

      <div className="flex items-center gap-2 text-xs font-medium text-slate-400">
        <span>Admin Portal</span>
        <span>/</span>
        <span className="text-amber-600 font-semibold">{title}</span>
      </div>
    </motion.div>
  );
}
